<template>
  <span class="extra-badge">
    <slot />
  </span>
</template>

<script>
export default {}
</script>
<style lang="scss" scoped>
  .extra-badge {
    @apply text-xs font-bold text-white-100 bg-primary-90 uppercase border-primary-80 border-solid border rounded-xl;
    padding: 2px 4px;
    line-height: 1;
  }
</style>
